// extracted by mini-css-extract-plugin
export default {"popupBody":"InfoWindow_popupBody__8Y7ya","closeBtn":"InfoWindow_closeBtn__ncqix"};